<template>
  <div
    class="pointer-events-auto flex flex-col rounded-[4px] bg-white text-type-secondary shadow-map"
    @pointerover="hovering = true"
    @pointerout="(hovering = false), (pressing = false)"
  >
    <gv-tooltip
      label="Zoom in"
      :floating-ui-options="{
        placement: 'left',
        offset: 16,
      }"
    >
      <button
        class="rounded-t-[4px]"
        :class="[buttonTheme]"
        type="button"
        @mousedown="pressing = true"
        @mouseup="pressing = false"
        @click="map.mapbox?.zoomIn()"
      >
        <gv-icon name="add" size="xs" aria-label="Zoom in" />
      </button>
    </gv-tooltip>

    <div
      class="h-px bg-grey-50 transition-all"
      :class="{
        'mx-2 w-4': !hovering && !pressing,
        'w-full': hovering && !pressing,
        'bg-primary-400': pressing,
      }"
    ></div>

    <gv-tooltip
      label="Zoom out"
      :floating-ui-options="{
        placement: 'left',
        offset: 16,
      }"
    >
      <button
        class="rounded-b-[4px]"
        :class="[buttonTheme]"
        type="button"
        @mousedown="pressing = true"
        @mouseup="pressing = false"
        @click="map.mapbox?.zoomOut()"
      >
        <gv-icon name="remove" size="xs" aria-label="Zoom out" />
      </button>
    </gv-tooltip>
  </div>
</template>

<script lang="ts" setup>
import { useMapStore } from '@/features/hazards';
import { ref } from 'vue';

const map = useMapStore();

const hovering = ref(false);
const pressing = ref(false);

const buttonTheme = 'transition-colors  h-8 w-8 flex items-center justify-center hover:bg-grey-50 active:bg-primary-400 active:fill-white';
</script>
